import Marquee from 'react-fast-marquee';
import { MARQUEE_ITEMS } from '../data/content';

export const MarqueeBand = () => (
    <div className="border-y border-slate-800 bg-navy-900/60 py-6" data-testid="disciplines-marquee" aria-hidden="true">
        <Marquee speed={28} gradient={false} pauseOnHover>
            {MARQUEE_ITEMS.map((item) => (
                <span key={item} className="mx-8 flex items-center gap-8 font-display text-lg sm:text-xl font-semibold tracking-wide text-slate-300">
                    {item}
                    <span className="inline-block h-1.5 w-1.5 rotate-45 bg-deepteal/60" />
                </span>
            ))}
        </Marquee>
    </div>
);
